export type { Theme } from './generalTheme'
export { generalTheme } from './generalTheme'
